import { Navigate, Routes, Route, useLocation } from 'react-router';
import { ProductDetails, RateCompare, Rates } from 'pages';
import { useUser } from 'libs';

const RatesLayout = () => {
  const location = useLocation();
  const user = useUser();
  return (
    <Routes>
      <Route path=":id" element={<ProductDetails />} />
      <Route
        path="compare"
        element={user.features.show_compare ? <RateCompare /> : <Navigate to="/rates/lenders" replace />}
      />
      <Route path="lenders" element={<Rates />} />
      <Route path="lenders/:id" element={<Rates />} />
      <Route path="products" element={<Rates />} />
      <Route index element={<Navigate to={`lenders${location.search}`} replace />} />
    </Routes>
  );
};

export default RatesLayout;
